import React from "react";
import { useSelector } from "react-redux";

import {
  religiousHistory,
  beard,
  readQuran,
  religiousSect,
  dailyPrayer,
  religiousCommitment,
  polygamy,
  hijab,
} from "../../utils/arrayitems";

import EditProfileBoxLabel from "../../components/label/editprofileboxlabel";
import Spacer from "../../components/spacer/spacer";
import EditProfileMultipleSelect from "../../components/dropdown/editprofilemultipleselection";
import { handleDoesntMatter } from "../../utils/handledoesntmatter";
import withDoesntMatter from "../../utils/doesntmatter";

import "./styles.css";

export default function ReligiousStatusFrom(props) {
  const gender = useSelector((state) => state.profile?.profile?.gender);

  return (
    <div className="adv-search-basic-info-area">
      <div
        style={{
          background: `radial-gradient(120% 110% at 80% 160%, #001528 74%, #073AFF00 92%),radial-gradient(150% 80% at 120% 115%, #02305E 70%, #073AFF00 88%),radial-gradient(140% 140% at 110% 140%, #5D4D8C 76%, #5E519200 92%, #073AFF00 100%),radial-gradient(75% 75% at 50% 50%, #362955 100%, #073AFF00 100%)`,
          backgroundSize: "100%",
          backgroundPosition: "center",
        }}
        className="adv-search-basic-info"
      >
        <h2 className="adv-search-info-title">Religious Status</h2>
      </div>
      <div className="adv-search-from-content">
        <div className="adv-search-from-left">
          {/* Religious History */}
          <div className="edit-profile-label-container">
            <EditProfileBoxLabel label="Religious History" />
          </div>
          <Spacer height="8px" />
          <EditProfileMultipleSelect
            placeholder="Religious History"
            data={withDoesntMatter(religiousHistory)}
            onChange={(e) =>
              handleDoesntMatter(props?.setState, "religiousHistory", e)
            }
            value={props?.state.religiousHistory || ""}
          />
          <Spacer height="8px" />
          {/* Beard/hijab */}
          <div className="edit-profile-label-container">
            <EditProfileBoxLabel
              label={gender?.toLowerCase() === "female" ? "Beard" : "Hijab"}
            />
          </div>
          <Spacer height="8px" />
          {gender?.toLowerCase() === "female" ? (
            <EditProfileMultipleSelect
              placeholder="Beard"
              data={withDoesntMatter(beard)}
              onChange={(e) => handleDoesntMatter(props?.setState, "beard", e)}
              value={props?.state.beard || ""}
            />
          ) : (
            <EditProfileMultipleSelect
              placeholder="Hijab"
              data={withDoesntMatter(hijab)}
              onChange={(e) => handleDoesntMatter(props?.setState, "hijab", e)}
              value={props?.state.hijab || ""}
            />
          )}

          <Spacer height="8px" />
          {/* Qur’an Reading */}
          <div className="edit-profile-label-container">
            <EditProfileBoxLabel label="Qur’an Reading" />
          </div>
          <Spacer height="8px" />
          <EditProfileMultipleSelect
            placeholder="Qur’an Reading"
            data={withDoesntMatter(readQuran)}
            onChange={(e) =>
              handleDoesntMatter(props?.setState, "readQuran", e)
            }
            value={props?.state.readQuran || ""}
          />
        </div>
        {/* Right From Area */}
        <div className="adv-search-from-right">
          {/* Sect */}
          <div className="edit-profile-label-container">
            <EditProfileBoxLabel label="Sect" />
          </div>
          <Spacer height="8px" />
          <EditProfileMultipleSelect
            placeholder="Sect"
            data={withDoesntMatter(religiousSect)}
            onChange={(e) =>
              handleDoesntMatter(props?.setState, "religiousSect", e)
            }
            value={props?.state.religiousSect || ""}
          />

          <Spacer height="8px" />

          {/* Daily Prayer */}
          <div className="edit-profile-label-container">
            <EditProfileBoxLabel label="Daily Prayer" />
          </div>
          <Spacer height="8px" />
          <EditProfileMultipleSelect
            placeholder="Daily Prayer"
            data={withDoesntMatter(dailyPrayer)}
            onChange={(e) =>
              handleDoesntMatter(props?.setState, "dailyPrayer", e)
            }
            value={props?.state.dailyPrayer || ""}
          />
          <Spacer height="8px" />

          {/* Religious Commitment Level */}
          <div className="edit-profile-label-container">
            <EditProfileBoxLabel label="Religious Commitment Level" />
          </div>
          <Spacer height="8px" />
          <EditProfileMultipleSelect
            placeholder="Religious Commitment Level"
            data={withDoesntMatter(religiousCommitment)}
            onChange={(e) =>
              handleDoesntMatter(props?.setState, "religiousCommitment", e)
            }
            value={props?.state.religiousCommitment || ""}
          />
          <Spacer height="8px" />

          {/* Polygamy */}
          <div className="edit-profile-label-container">
            <EditProfileBoxLabel label="Polygamy" />
          </div>
          <Spacer height="8px" />
          <EditProfileMultipleSelect
            placeholder="Polygamy"
            data={withDoesntMatter(polygamy)}
            onChange={(e) => handleDoesntMatter(props?.setState, "polygamy", e)}
            value={props?.state.polygamy || ""}
          />
          <Spacer height="8px" />
        </div>
      </div>
    </div>
  );
}
